module.exports = __webpack_public_path__ + "static/media/idlingClouds.81c60e05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Idling/idlingClouds.svg
// module id = 925
// module chunks = 0